const listqueuepermission = (state = [], action) => {
    switch (action.type) {
      case 'QUEUEPERMISSION':
      return {
          type: "QUEUEPERMISSION",
          queuepermission: action.queuepermission
        }
      default:
        return state
    }
  }
  
  export default listqueuepermission